import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../services/rh'
import Terceirizado from './terceirizado';

const ListarTerceirizados = () => {

    const [terceirizados, setTerceirizados] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [empresas, setEmpresas] = useState([]);

    async function fetchTerceirizados() {
        await montaSelectEmpresaCargos()
        const response = await RHService.listarTerceirizados();
        if (response.data.length >= 1) {
            setTerceirizados(response.data)
            setVazio(false)
        } else {
            setTerceirizados([])
            setVazio(true)
        }
    }

    const montaSelectEmpresaCargos = async () => {
        const prod = await RHService.listarTerceirizados();
        setEmpresas(prod.data)
    }

    useEffect(() => {
        fetchTerceirizados();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setTerceirizados={setTerceirizados}
                    setVazio={setVazio}
                    empresas={empresas}
                    fetchTerceirizados={fetchTerceirizados}
                    terceirizados={terceirizados}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h2>Funcionários Terceirizados em Macuco</h2>
                    <Row xs={3}>
                        {terceirizados.map((terc, index) =>
                            <Terceirizado
                                terc={terc}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarTerceirizados;